
    import './styles.scoped.css';
    export default {
  "wrapper": "awsui_wrapper_z5mul_131z0_99",
  "wrapper--fit-height": "awsui_wrapper--fit-height_z5mul_131z0_135",
  "inner-wrapper--fit-height": "awsui_inner-wrapper--fit-height_z5mul_131z0_140",
  "has-default-filter": "awsui_has-default-filter_z5mul_131z0_146",
  "content": "awsui_content_z5mul_131z0_150",
  "content--reserve-filter": "awsui_content--reserve-filter_z5mul_131z0_157",
  "content--reserve-legend": "awsui_content--reserve-legend_z5mul_131z0_161",
  "content--fit-height": "awsui_content--fit-height_z5mul_131z0_165",
  "filter-container": "awsui_filter-container_z5mul_131z0_169"
};
  